interface VideoPlayerProps {
  src: string;
  poster: string;
  title: string;
}

export default function VideoPlayer({ src, poster, title }: VideoPlayerProps) {
  return (
    <div className="w-full">
      <div className="relative w-full aspect-video rounded-lg overflow-hidden bg-secondary-950">
        <video
          controls
          poster={poster}
          preload="metadata"
          className="w-full h-full object-contain bg-secondary-950"
          aria-label={title}
        >
          <source src={src} type="video/mp4" />
          你的浏览器暂不支持视频播放，请更换浏览器后重试。
        </video>
      </div>
      <p className="mt-3 text-xs text-foreground-400 flex items-start gap-1.5">
        <i className="ri-information-line mt-0.5" />
        当前播放的是示例视频，仅用于演示播放器功能；正式片源接口待对接，上线后将替换为平台自有内容。
      </p>
    </div>
  );
}